module.exports = __webpack_public_path__ + "img/ธนาคารอิสลาม.aadc3abc.jpg";